// extracted by mini-css-extract-plugin
export default {"documentUploaderManagerHeader":"li3SDvOKcSFcW0uBPu98"};